// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"36243fc2","419":"66d4881b","485":"e5a414bc","598":"b6b5dcfb","958":"f0161e30"}[chunkId] + ".chunk.css";
};